
import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import MessageDialog from "../../components/MessageDialog";
import StorageService from "../../services/StorageService";
import VehicleReportService from "../../services/vehicleReportService";
import ProjectService from "../../services/ProjectService";
import VehicleRegistrationService from "../../services/vehicleRegistrationService";
import utility from "./../../utils/utility";
import ReactPaginate from "react-paginate";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import XLSX from "xlsx-js-style";
import logo from '../../assets/images/deviops_logo.png';
import { addPdfLogo, getPdfLogoDataUrl } from "../../utils/pdfLogo";

export default function VehicleReadingReport() {
  const [reports, setReports] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);

  const getFirstDayOfMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}-01`;
  };

  const getLastDayOfMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const monthStr = String(month).padStart(2, "0");
    const dayStr = String(lastDay).padStart(2, "0");
    return `${year}-${monthStr}-${dayStr}`;
  };

  const [vehicleType, setVehicleType] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [fromDate, setFromDate] = useState(getFirstDayOfMonth());
  const [toDate, setToDate] = useState(getLastDayOfMonth());
  const [projects, setProjects] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [readingDate, setReadingDate] = useState("");

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const roleId = StorageService.loginData().roleId;
  const employeeId = StorageService.loginData().employeeId;


  const formatDateTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d)) return "-";
    const date = d.toISOString().slice(0, 10);
    const time = d.toTimeString().slice(0, 5);
    return `${date} ${time}`;
  };

  useEffect(() => {
    loadProjects();
    handleSearch();
  }, []);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  // 🔹 Load projects (same logic as AddVehicleReading)
  const loadProjects = async () => {
    try {
      const companyId = StorageService.activeCompany().companyId;
      const employeeId = StorageService.loginData().employeeId;
      const res = await ProjectService.getActiveProjectsByEmployee(
        companyId,
        employeeId
      );
      const data = res?.data || res || [];

      const mapped = data.map(p => ({
        id: p.id || p.projectId,
        projectId: p.id || p.projectId,
        projectName: p.projectName,
        projectCode: p.projectCode,
        categoryName: p.projectCategoryName || p.categoryName || p.projectCategory || p.category || ""
      }));

      setProjects(mapped);

    } catch {
      setProjects([]);
    }
  };

  // 🔹 Load vehicles when project changes
  const fetchVehicles = async (projectId) => {
    if (!projectId) {
      setVehicles([]);
      return;
    }
    try {
      const res = await VehicleRegistrationService.getByProjectId(projectId, true);
      setVehicles(res?.status ? res.data : res?.data || res || []);
    } catch {
      setVehicles([]);
    }
  };

  const handleProjectChange = (e) => {
    const value = e.target.value;
    setSelectedProjectId(value);
    setSelectedVehicleId("");
    setVehicleType("");
    setVendorName("");
    fetchVehicles(value);
  };





  const handleSearch = async () => {
    // if (!selectedProjectId && !selectedVehicleId && !readingDate) {
    //   showMessage("Please select at least one filter");
    //   return;
    // }

    setLoading(true);
    try {
      setPageCount(1);
      // setCurrentPage(1);
      setReports([]);
      const companyId = StorageService.activeCompany().companyId;

      const res = await VehicleReportService.getVehicleReadingReport({
        pageNumber: currentPage,
        noofRows: itemsPerPage,
        companyId,
        roleId,
        employeeId: null,
        project: selectedProjectId || null,
        vehicleNumber: null,
        vehicleName: selectedVehicleId || null,
        vehicleType: vehicleType || null,
        vendorName: vendorName || null,

        fromDate: readingDate || fromDate || null,
        toDate: readingDate || toDate || null
      });

      const data = res.data || [];
      // setPageCount(res.pagination?.totalPages || 1);
      setPageCount(res.pageNation?.totalPages || 1);
      setReports(data);
      setExpandedRow(null);

    } catch (error) {
      console.error(error);
      showMessage("Error fetching vehicle report", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [currentPage]);

  // useEffect(() => {
  //   if (currentPage !== 1) {
  //     handleSearch();   // reuse same function
  //   }
  // }, [currentPage]);




  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  // const handleSearchClick = () => {
  //   setCurrentPage(1);
  //   handleSearch();
  // };

  const handleSearchClick = () => {
    setCurrentPage(1);

    if (currentPage === 1) {
      handleSearch();
    }
  };

  const handleClearFilters = () => {
    // reset all filters
    setSelectedProjectId("");
    setSelectedVehicleId("");
    setVehicleType("");
    setVendorName("");
    setFromDate(getFirstDayOfMonth());
    setToDate(getLastDayOfMonth());
    setReadingDate("");

    // reset dependent data
    setVehicles([]);

    // reset pagination
    setCurrentPage(1);

    // optional: reload full data
    handleSearch();
  };

  const handleExportPDF = async () => {
    if (handleExportPDFV2) {
      return handleExportPDFV2();
    }

    // Validate required fields for export
    if (!selectedVehicleId) {
      showMessage("Vehicle ID is required", "error");
      return;
    }

    if (!readingDate && !fromDate) {
      showMessage("Start date is required", "error");
      return;
    }

    if (!toDate && !readingDate) {
      showMessage("End date is required", "error");
      return;
    }

    const companyId = StorageService.activeCompany().companyId;

    const res = await VehicleReportService.getVehicleReadingReportDetails({
      vehicleId: selectedVehicleId,
      projectId: selectedProjectId,
      companyId,
      fromDate: readingDate || fromDate,
      toDate: readingDate || toDate
    });

    if (!res?.data) {
      showMessage("No data found", "error");
      return;
    }

    const { header = {}, summary = {}, charges = {}, table = [] } = res.data;

    const doc = new jsPDF("p", "mm", "a4");

    const activeCompany = StorageService.activeCompany();
    const companyName = activeCompany?.companyName || "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    const companyNameWidth = doc.getTextWidth(companyName);
    const logoX = 14 + (companyNameWidth - 9) / 2;

    await addPdfLogo(doc, logo, logoX, 10, 9, 15);

    // Company name
    doc.text(companyName, 14, 30);

    // Report date
    doc.setFontSize(10);
    doc.text(`Report Date: ${utility.formatDateDDMMMYYYY(new Date())}`, 180, 20, { align: "right" });

    // 🔷 TITLE
    doc.setFontSize(16);
    doc.text("Vehicle Reading Report", 105, 40, { align: "center" });

    doc.setFontSize(10);

    const getFormattedProjName = (pName, cName, pId) => {
      if (!pName) return "-";
      let cat = cName;
      if (!cat && projects && projects.length) {
        const found = projects.find(p =>
          (pId && String(p.id || p.projectId) === String(pId)) ||
          (selectedProjectId && String(p.id || p.projectId) === String(selectedProjectId)) ||
          (p.projectName && String(p.projectName).trim().toLowerCase() === String(pName).trim().toLowerCase())
        );
        if (found) cat = found.categoryName || found.projectCategoryName || found.projectCategory || found.category;
      }
      const initial = String(cat || "").trim().charAt(0).toUpperCase();
      return initial ? `${initial}*${pName}` : pName;
    };

    // 🔷 HEADER
    doc.text(`Project: ${getFormattedProjName(header.projectName, header.projectCategoryName || header.categoryName, selectedProjectId)}`, 14, 50);
    doc.text(`Vehicle: ${header.vehicleName} (${header.vehicleNo})`, 14, 55);
    doc.text(`Type: ${header.vehicleType}`, 14, 60);
    doc.text(`Vendor: ${header.vendorName}`, 14, 65);

    doc.text(`Hire Type: ${header.hireType}`, 120, 50);
    doc.text(`Rate: ${header.hireRate}`, 120, 55);
    doc.text(`Reading Type: ${header.readingType}`, 120, 60);
    doc.text(`Fuel By: ${header.fuelBorneBy}`, 120, 65);

    // 🔷 SUMMARY BOX
    autoTable(doc, {
      startY: 70,
      theme: "grid",
      body: [
        ["Working Days", summary.workingDays, "Idle Days", summary.idleDays],
        ["Breakdown Days", summary.breakdownDays, "Total Days", summary.totalDays],
        ["Start Reading", summary.startReading, "End Reading", summary.endReading],
        ["Total Reading", summary.totalReading, "Fuel Amount", summary.totalFuelAmount],
      ]
    });

    // 🔷 CHARGES
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 5,
      theme: "grid",
      body: [
        ["Total Hire Charges", charges.totalHire],
        ["Balance Payable", charges.totalHire]
      ]
    });

    // 🔷 TABLE DATA
    const tableData = table.map(r => [
      utility.formatDateDDMMMYYYY(r.date),
      r.status,
      r.start || 0,
      r.end || 0,
      r.total,
      r.fuelAmount
    ]);

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 5,
      head: [["Date", "Status", "Start", "End", "Total", "Fuel"]],
      body: tableData,
      theme: "grid"
    });

    // 🔷 FOOTER (Page Number Center)
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text(`Page ${i} of ${pageCount}`, 105, 290, { align: "center" });
    }

    doc.save("Vehicle_Report.pdf");
  };

  const handleExportPDFV2 = async () => {

    // Validate required fields for export
    if (!selectedVehicleId) {
      showMessage("Vehicle ID is required", "error");
      return;
    }

    if (!readingDate && !fromDate) {
      showMessage("Start date is required", "error");
      return;
    }

    if (!toDate && !readingDate) {
      showMessage("End date is required", "error");
      return;
    }

    const companyId = StorageService.activeCompany().companyId;

    const res = await VehicleReportService.getVehicleReadingReportDetails({
      vehicleId: selectedVehicleId,
      projectId: selectedProjectId,
      companyId,
      fromDate: readingDate || fromDate,
      toDate: readingDate || toDate
    });

    if (!res?.data) {
      showMessage("No data found", "error");
      return;
    }

    const { header = {}, summary = {}, charges = {}, table = [] } = res.data;
    const doc = new jsPDF("landscape", "mm", "a4");
    const pdfLogo = await getPdfLogoDataUrl(logo);
    const activeCompany = StorageService.activeCompany();
    const companyName = activeCompany?.companyName || "Devi Projects";
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageMargin = 10;
    const left = pageMargin;
    const right = pageWidth - pageMargin;
    const printableWidth = right - left;
    const firstPageTableTop = 113;
    const continuedPageTableTop = 45;
    const footerTop = pageHeight - 25;

    const value = (...items) => {
      const item = items.find(v => v !== undefined && v !== null && v !== "");
      return item === undefined ? "" : item;
    };
    // const formatReportDateTime = (date) => {
    //   const pad = (n) => String(n).padStart(2, "0");
    //   return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    // };
    const formatPdfDate = (date) => date ? utility.formatDateDDMMMYYYY(date) : "";
    const formatNumber = (number, decimals = 2) => {
      const parsed = Number(number);
      if (!Number.isFinite(parsed)) return value(number, "");
      return parsed.toLocaleString("en-IN", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    };
    const formatReading = (number) => {
      const parsed = Number(number);
      if (!Number.isFinite(parsed)) return value(number, "0.00");
      return parsed.toFixed(2);
    };
    const calculateReading = (row) => {
      const backendTotal = Number(value(row.total, row.totalReading, ""));
      const rawStart = value(row.start, row.startReading, row.fromReading, "");
      const rawEnd = value(row.end, row.endReading, row.toReading, "");

      if (Number.isFinite(backendTotal) && backendTotal !== 0) {
        return backendTotal;
      }

      if (rawStart !== "" && rawStart !== null && rawEnd !== "" && rawEnd !== null) {
        const start = Number(rawStart);
        const end = Number(rawEnd);
        if (Number.isFinite(start) && Number.isFinite(end)) {
          return end - start;
        }
      }

      return Number.isFinite(backendTotal) ? backendTotal : 0;
    };

    const pdfVehicleAvg = () => {
      const fuelVal = Number(value(summary.totalFuelLiters, summary.totalFuel, table.reduce((sum, row) => sum + Number(value(row.fuelLiters, row.fuelLtrs, row.fuel, 0)), 0)));
      const readingVal = Number(table.reduce((sum, row) => sum + calculateReading(row), 0));
      if (readingVal > 0 && fuelVal > 0) {
        const rType = String(value(header.readingType, "")).toLowerCase().trim();
        const isHourOrCustom = rType.includes("hour") || rType.includes("custom") || rType.includes("hr");
        const avg = isHourOrCustom ? fuelVal / readingVal : readingVal / fuelVal;
        return Number.isFinite(avg) ? avg : 0;
      }
      return 0;
    };

    const getSafeAvg = (val) => {
      const parsed = Number(val);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const cell = (x, y, w, h, text, options = {}) => {
      const { bold = false, align = "left", fillColor, fontSize = 8, color = [0, 0, 0] } = options;
      if (fillColor) {
        doc.setFillColor(...fillColor);
        doc.rect(x, y, w, h, "FD");
      } else {
        doc.rect(x, y, w, h);
      }
      doc.setFontSize(fontSize);
      doc.setTextColor(...color);
      doc.setFont(undefined, bold ? "bold" : "normal");
      const textX = align === "right" ? x + w - 1.5 : align === "center" ? x + w / 2 : x + 1.3;
      doc.text(String(value(text, "")), textX, y + h - 2.2, { align });
      doc.setTextColor(0, 0, 0);
    };

    // const drawHeader = (pageNumber) => {
    //   doc.setDrawColor(0, 0, 0);
    //   doc.setLineWidth(0.2);

    //   const rowH = 7;

    //   // Only draw header on first page
    //   if (pageNumber === 1) {
    //     doc.setFont(undefined, "bold");
    //     doc.setFontSize(12);
    //     doc.setTextColor(0, 0, 0);
    //     const companyNameWidth = doc.getTextWidth(companyName);
    //     const logoX = left + 6 + (companyNameWidth - 9) / 2;

    //     doc.addImage(pdfLogo, "PNG", logoX, 3, 9, 15);
    //     doc.text(companyName, left + 6, 22);

    //     doc.setFontSize(18);
    //     doc.setFont(undefined, "bold");
    //     doc.text("Vehicle Reading Report", pageWidth / 2, 22, { align: "center" });

    //     doc.setFontSize(10);
    //     doc.text(`Report Date: ${utility.formatExportDateTime(new Date())}`, right, 15, { align: "right" });
    //     doc.setFont(undefined, "normal");

    //     doc.setFont(undefined, "bold");
    //     doc.text("Project Name:", left, 40);
    //     doc.text(`${value(header.projectName, "")}${header.projectCode ? ` - ${header.projectCode}` : ""}`, left + 40, 40);

    //     const infoY = 45;
    //     const widths = [39, 35, 31, 33, 32, 31, 34, printableWidth - 235];
    //     const xs = widths.reduce((acc, w, index) => {
    //       acc.push(index === 0 ? left : acc[index - 1] + widths[index - 1]);
    //       return acc;
    //     }, []);

    //     [
    //       ["Vehicle Type:", value(header.vehicleType), "Vehicle No:", value(header.vehicleNo, header.registrationNo), "Vehicle Owner:", value(header.vehicleOwner, header.vendorName), "Fuel Borne By:", value(header.fuelBorneBy)],
    //       ["Hire Date:", formatPdfDate(value(header.hireStartDate, header.vehicleHireStartDate, header.hireDate, header.startDate)), "Hire Type:", value(header.hireType, header.leaseType), "Hire Rate:", formatNumber(value(header.hireRate, header.vehicleHirerate, 0)), "Reading Type:", value(header.readingType)]
    //     ].forEach((row, rowIndex) => {
    //       row.forEach((text, index) => {
    //         cell(xs[index], infoY + rowIndex * rowH, widths[index], rowH, text, {
    //           bold: index % 2 === 0,
    //           align: index === 5 ? "right" : "left"
    //         });
    //       });
    //     });
    //   }

    //   if (pageNumber !== 1) {
    //     return;
    //   }

    //   const sumY = 74;
    //   const sumWidths = [39, 35, 31, 33, 32, 28];
    //   const sumXs = sumWidths.reduce((acc, w, index) => {
    //     acc.push(index === 0 ? left : acc[index - 1] + sumWidths[index - 1]);
    //     return acc;
    //   }, []);
    //   [
    //     ["Working Days:", value(summary.workingDays, 0), "Idle Days:", value(summary.idleDays, 0), "Break Down Days:", value(summary.breakdownDays, summary.breakDownDays, 0)],
    //     ["Start Date:", formatPdfDate(value(summary.startDate, fromDate, readingDate)), "End Date", formatPdfDate(value(summary.endDate, toDate, readingDate)), "Total Days:", value(summary.totalDays, 0)],
    //     ["Start Reading:", formatReading(value(summary.startReading, 0)), "End Reading:", formatReading(value(summary.endReading, 0)), "Total Reading", formatReading(sortedTable.reduce((sum, row) => sum + calculateReading(row), 0))],
    //     ["Total Fuel(Ltrs):", formatNumber(value(summary.totalFuelLiters, summary.totalFuel, 0)), "Total Fule Amt:", formatNumber(value(summary.totalFuelAmount, 0)), "Vehicle Avg:", formatNumber(value(summary.vehicleAvg, summary.vehicleAverage, 0))]
    //   ].forEach((row, rowIndex) => {
    //     row.forEach((text, index) => {
    //       cell(sumXs[index], sumY + rowIndex * rowH, sumWidths[index], rowH, text, {
    //         bold: index % 2 === 0
    //       });
    //     });
    //   });

    //   const chargeY = 106;
    //   const lessDiesel = value(charges['fuel-charges'], charges.lessDiesel, charges.dieselAmount, summary.totalFuelAmount, "");
    //   const balancePayable = value(
    //     charges.balancePayable,
    //     charges.balance,
    //     Number(value(charges.totalHire, 0)) - Number(value(lessDiesel, 0))
    //   );

    //   [
    //     ["Total Hire Charges:", formatNumber(value(charges.totalHire, charges.totalHireCharges, 0))],
    //     ["Fuel Charges:", formatNumber(lessDiesel)],
    //     ["Balance Payable:", formatNumber(balancePayable)]
    //   ].forEach((row, index) => {
    //     cell(left, chargeY + index * rowH, 39, rowH, row[0], { bold: true, fontSize: index === 2 ? 11 : 8 });
    const drawHeader = (pageNumber) => {

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.2);

      // Set font and size first so getTextWidth returns the correct width
      doc.setFont(undefined, "bold");
      doc.setFontSize(12);
      const companyNameWidth = doc.getTextWidth(companyName);

      // Centered logo directly above the company name (width: 5, height: 10)
      const logoWidth = 5;
      const logoHeight = 10;
      const logoX = left + 6 + (companyNameWidth - logoWidth) / 2;
      const logoY = 8;

      doc.addImage(
        pdfLogo,
        "PNG",
        logoX,
        logoY,
        logoWidth,
        logoHeight
      );

      // Company name and report date at the same level (Y = 23)
      doc.text(
        companyName,
        left + 6,
        23
      );

      const reportPrefix = "Report Date: ";
      const reportDateStr = utility.formatExportDateTime(new Date());

      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      const prefixWidth = doc.getTextWidth(reportPrefix);

      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      const dateWidth = doc.getTextWidth(reportDateStr);

      const totalWidth = prefixWidth + dateWidth;
      const startX = right - totalWidth;

      doc.setFont(undefined, "bold");
      doc.text(reportPrefix, startX, 23);

      doc.setFont(undefined, "normal");
      doc.text(reportDateStr, startX + prefixWidth, 23);

      // Title below them (Y = 35) with underline (Y = 37)
      doc.setFontSize(18);
      doc.text(
        "Vehicle Reading Report",
        pageWidth / 2,
        35,
        { align: "center" }
      );

      doc.line(
        pageWidth / 2 - 35,
        37,
        pageWidth / 2 + 35,
        37
      );

      // First page only
      if (pageNumber === 1) {

        const rowH = 7;

        // Project name label and value on same Y (53) with exactly one space gap
        doc.setFont(undefined, "bold");
        doc.setFontSize(10);
        doc.text("Project Name:", left, 53);

        const labelWidth = doc.getTextWidth("Project Name:");
        doc.setFont(undefined, "normal");
        const foundProjCat = header.projectCategoryName || header.categoryName || (projects.find(p => String(p.id || p.projectId) === String(selectedProjectId) || (header.projectName && String(p.projectName).trim().toLowerCase() === String(header.projectName).trim().toLowerCase()))?.categoryName) || "";
        const projCatInit = String(foundProjCat).trim().charAt(0).toUpperCase();
        const projFormatted = header.projectName ? (projCatInit ? `${projCatInit}*${header.projectName}` : header.projectName) : "";
        doc.text(
          `${value(projFormatted, "")}`,
          left + labelWidth + 2,
          53
        );

        // Shifted Vehicle info coordinates (infoY = 58)
        const infoY = 58;

        const widths = [33, 34, 27, 32, 40, 34, 44, 33];

        const xs = widths.reduce((acc, w, index) => {
          acc.push(index === 0 ? left : acc[index - 1] + widths[index - 1]);
          return acc;
        }, []);

        [
          [
            "Vehicle Type:",
            value(header.vehicleType),
            "Vehicle No:",
            value(header.vehicleNo, header.registrationNo),
            "Vendor(Vehicle Owner):",
            value(header.vehicleOwner, header.vendorName),
            "Reading Type:",
            value(header.readingType)
          ],
          [
            "Hire Date:",
            formatPdfDate(
              value(
                header.hireStartDate,
                header.vehicleHireStartDate,
                header.hireDate,
                header.startDate
              )
            ),
            "Hire Type:",
            value(header.hireType, header.leaseType),
            "Hire Rate:",
            formatNumber(value(header.hireRate, header.vehicleHirerate, 0)),
            "Fuel Borne By:",
            value(header.fuelBorneBy)
          ]
        ].forEach((row, rowIndex) => {
          row.forEach((text, index) => {
            cell(
              xs[index],
              infoY + rowIndex * rowH,
              widths[index],
              rowH,
              text,
              {
                bold: index % 2 === 0
              }
            );
          });
        });

        // Shifted summary/charges coordinates (sumY = 75, chargeY = 75)
        const sumY = 75;

        const sumWidths = [39, 35, 31, 33, 32, 28];

        const sumXs = sumWidths.reduce((acc, w, index) => {
          acc.push(index === 0 ? left : acc[index - 1] + sumWidths[index - 1]);
          return acc;
        }, []);

        [
          [
            "Working Days:",
            value(summary.workingDays, 0),
            "Idle Days:",
            value(summary.idleDays, 0),
            "Break Down Days:",
            value(summary.breakdownDays, summary.breakDownDays, 0)
          ],
          [
            "Start Date:",
            formatPdfDate(value(summary.startDate, fromDate, readingDate)),
            "End Date:",
            formatPdfDate(value(summary.endDate, toDate, readingDate)),
            "Total Days:",
            value(summary.totalDays, 0)
          ],
          [
            "Start Reading:",
            formatReading(value(summary.startReading, 0)),
            "End Reading:",
            formatReading(value(summary.endReading, 0)),
            "Total Reading:",
            formatReading(
              sortedTable.reduce(
                (sum, row) => sum + calculateReading(row),
                0
              )
            )
          ],
          [
            value(summary.fuelType, header.fuelType)
              ? `Total Fuel(Ltrs) (${value(summary.fuelType, header.fuelType)}):`
              : "Total Fuel(Ltrs):",
            formatNumber(value(summary.totalFuelLiters, summary.totalFuel, 0)),
            "Total Fuel Amt:",
            formatNumber(value(summary.totalFuelAmount, 0)),
            "Vehicle Avg:",
            formatNumber(
              getSafeAvg(value(summary.vehicleAvg, summary.vehicleAverage, pdfVehicleAvg()))
            )
          ]
        ].forEach((row, rowIndex) => {
          row.forEach((text, index) => {
            cell(
              sumXs[index],
              sumY + rowIndex * rowH,
              sumWidths[index],
              rowH,
              text,
              {
                bold: index % 2 === 0
              }
            );
          });
        });

        const chargeY = 75;
        const chargeX = 210;
        const chargeCol1W = 44;
        const chargeCol2W = right - chargeX - chargeCol1W;

        const lessDiesel = value(
          charges["fuel-charges"],
          charges.lessDiesel,
          charges.dieselAmount,
          summary.totalFuelAmount,
          ""
        );

        const balancePayable = value(
          charges.balancePayable,
          charges.balance,
          Number(value(charges.totalHire, 0)) -
          Number(value(lessDiesel, 0))
        );

        doc.setLineWidth(0.6);
        [
          [
            "Total Hire Charges:",
            formatNumber(
              value(
                charges.totalHire,
                charges.totalHireCharges,
                0
              )
            )
          ],
          [
            "Fuel Charges:",
            formatNumber(lessDiesel)
          ],
          [
            "Balance Payable:",
            formatNumber(balancePayable)
          ]
        ].forEach((row, index) => {

          cell(
            chargeX,
            chargeY + index * rowH,
            chargeCol1W,
            rowH,
            row[0],
            {
              bold: true
            }
          );

          cell(
            chargeX + chargeCol1W,
            chargeY + index * rowH,
            chargeCol2W,
            rowH,
            row[1],
            {
              bold: true,
              align: "right"
            }
          );

        });
        doc.setLineWidth(0.2);
      }
    };

    const drawPageNumber = (pageNumber, totalPages) => {
      doc.setFont(undefined, "normal");
      doc.setFontSize(8);
      const text = totalPages
        ? `Page ${pageNumber} of ${totalPages}`
        : `Page ${pageNumber}`;
      doc.text(text, pageWidth / 2, pageHeight - 7, { align: "center" });
    };

    const drawSignatureHeadings = () => {
      doc.setFont(undefined, "bold");
      doc.setFontSize(8);
      doc.text("Prepared By", left + 30, footerTop + 4);
      doc.text("Checked By", pageWidth / 2, footerTop + 4, { align: "center" });
      doc.text("Approved By", right - 30, footerTop + 4, { align: "center" });
    };

    const sortedTable = [...table].sort((a, b) => {
      const dateA = new Date(a.date || a.readingDate || 0).getTime();
      const dateB = new Date(b.date || b.readingDate || 0).getTime();
      return dateA - dateB;
    });

    const tableData = sortedTable.map(r => {
      const startReadingDisplay =
        r.fromReading !== null && r.fromReading !== "" && r.fromReading !== undefined
          ? formatReading(r.fromReading)
          : r.startTime
            ? utility.formatDbDateTime(r.startTime)
            : "-";
      const endReadingDisplay =
        r.toReading !== null && r.toReading !== "" && r.toReading !== undefined
          ? formatReading(r.toReading)
          : r.endTime
            ? utility.formatDbDateTime(r.endTime)
            : "-";

      return [
        formatPdfDate(value(r.date, r.readingDate)),
        value(r.status, r.machineStatus),
        value(r.readingType, header.readingType, "-"),
        startReadingDisplay,
        endReadingDisplay,
        formatReading(calculateReading(r)),
        formatNumber(value(r.fuelLiters, r.fuelLtrs, r.fuel, 0)),
        formatNumber(value(r.rate, 0)),
        formatNumber(value(r.fuelAmount, 0)),
        value(r.driverName, "-")
      ];
    });

    const totalReading = formatReading(sortedTable.reduce((sum, row) => sum + calculateReading(row), 0));
    const totalFuel = formatNumber(value(summary.totalFuelLiters, summary.totalFuel, sortedTable.reduce((sum, row) => sum + Number(value(row.fuelLiters, row.fuelLtrs, row.fuel, 0)), 0)));
    const totalFuelAmount = formatNumber(value(summary.totalFuelAmount, sortedTable.reduce((sum, row) => sum + Number(value(row.fuelAmount, 0)), 0)));

    autoTable(doc, {
      startY: firstPageTableTop,
      margin: {
        top: continuedPageTableTop,
        left,
        right: pageMargin,
        bottom: 30
      },
      head: [["Date", "Work Status", "Reading Type", "Start Reading", "End Reading", "Total Reading", "Fuel(Ltrs)", "Rate/Ltr", "Fuel Amount", "Driver Name"]],
      body: tableData,
      foot: [["", "", "", "", "Total:", totalReading, totalFuel, "", totalFuelAmount, ""]],
      showFoot: "lastPage",
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 1,
        lineColor: [0, 0, 0],
        lineWidth: 0.15,
        textColor: [0, 0, 0],
        minCellHeight: 5.2
      },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center"
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255]
      },
      footStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "right"
      },
      columnStyles: {
        0: { cellWidth: 24, halign: "center" },
        1: { cellWidth: 24, halign: "left" },
        2: { cellWidth: 26, halign: "left" },
        3: { cellWidth: 32, halign: "right" },
        4: { cellWidth: 32, halign: "right" },
        5: { cellWidth: 24, halign: "right" },
        6: { cellWidth: 24, halign: "right" },
        7: { cellWidth: 22, halign: "right" },
        8: { cellWidth: 26, halign: "right" },
        9: { cellWidth: "auto", halign: "left" }
      },
      didDrawPage: (data) => {
        drawHeader(data.pageNumber);
      }
    });

    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      if (i === pageCount) {
        drawSignatureHeadings();
      }
      drawPageNumber(i, pageCount);
    }

    doc.save("Vehicle_Reading_Report.pdf");
  };

  const handleExportExcel = async () => {
    // Validate required fields for export
    if (!selectedVehicleId) {
      showMessage("Vehicle ID is required", "error");
      return;
    }

    if (!readingDate && !fromDate) {
      showMessage("Start date is required", "error");
      return;
    }

    if (!toDate && !readingDate) {
      showMessage("End date is required", "error");
      return;
    }

    try {
      const companyId = StorageService.activeCompany().companyId;
      const res = await VehicleReportService.getVehicleReadingReportDetails({
        vehicleId: selectedVehicleId,
        projectId: selectedProjectId,
        companyId,
        fromDate: readingDate || fromDate,
        toDate: readingDate || toDate
      });

      if (res?.status === false) {
        showMessage(res?.message || "Error fetching report data", "error");
        return;
      }

      generateExcelReport(res?.data);
    } catch (error) {
      console.error("Excel export error:", error);
      showMessage("Error exporting to Excel", "error");
    }
  };

  const generateExcelReport = (data) => {
    if (!data || !data.header) {
      showMessage("No data available for export", "error");
      return;
    }

    const { header = {}, summary = {}, charges = {}, table = [] } = data;

    const pickValue = (...items) => {
      const item = items.find((v) => v !== undefined && v !== null && v !== "");
      return item === undefined ? "" : item;
    };

    const calculateReading = (row) => {
      const backendTotal = Number(pickValue(row.total, row.totalReading, ""));
      const rawStart = pickValue(row.start, row.startReading, row.fromReading, "");
      const rawEnd = pickValue(row.end, row.endReading, row.toReading, "");

      if (Number.isFinite(backendTotal) && backendTotal !== 0) {
        return backendTotal;
      }
      if (rawStart !== "" && rawStart !== null && rawEnd !== "" && rawEnd !== null) {
        const start = Number(rawStart);
        const end = Number(rawEnd);
        if (Number.isFinite(start) && Number.isFinite(end)) {
          return end - start;
        }
      }
      return Number.isFinite(backendTotal) ? backendTotal : 0;
    };

    const sortedTable = [...table].sort((a, b) => {
      const dateA = new Date(a.date || a.readingDate || 0).getTime();
      const dateB = new Date(b.date || b.readingDate || 0).getTime();
      return dateA - dateB;
    });

    const totalReadingSum = sortedTable.reduce((sum, row) => sum + calculateReading(row), 0);
    const totalFuelSum = sortedTable.reduce(
      (sum, row) => sum + Number(pickValue(row.fuelLiters, row.fuelLtrs, row.fuel, 0)),
      0
    );
    const totalFuelAmountSum = Number(
      pickValue(
        summary.totalFuelAmount,
        sortedTable.reduce((sum, row) => sum + Number(pickValue(row.fuelAmount, 0)), 0)
      )
    ) || 0;

    const excelVehicleAvg = () => {
      const fuelVal = Number(pickValue(summary.totalFuelLiters, summary.totalFuel, totalFuelSum));
      const readingVal = Number(totalReadingSum);
      if (readingVal > 0 && fuelVal > 0) {
        const rType = String(pickValue(header.readingType, "")).toLowerCase().trim();
        const isHourOrCustom = rType.includes("hour") || rType.includes("custom") || rType.includes("hr");
        const avg = isHourOrCustom ? fuelVal / readingVal : readingVal / fuelVal;
        return Number.isFinite(avg) ? avg : 0;
      }
      return 0;
    };

    const getSafeAvg = (val) => {
      const parsed = Number(val);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const lessDiesel = Number(
      pickValue(
        charges["fuel-charges"],
        charges.lessDiesel,
        charges.dieselAmount,
        summary.totalFuelAmount,
        0
      )
    ) || 0;

    const balancePayable = Number(
      pickValue(
        charges.balancePayable,
        charges.balance,
        Number(pickValue(charges.totalHire, charges.totalHireCharges, 0)) - lessDiesel
      )
    ) || 0;

    const wb = XLSX.utils.book_new();
    const ws = {};
    ws["!merges"] = [];

    const thin = { style: "thin" };
    const cellBorder = { top: thin, bottom: thin, left: thin, right: thin };
    const center = { horizontal: "center", vertical: "center", wrapText: true };
    const leftAlign = { horizontal: "left", vertical: "center", wrapText: true };
    const rightAlign = { horizontal: "right", vertical: "center" };
    const labelStyle = {
      font: { bold: true, sz: 10 },
      alignment: leftAlign,
      border: cellBorder
    };
    const valueStyle = {
      font: { sz: 10 },
      alignment: leftAlign,
      border: cellBorder
    };
    const numStyle = {
      font: { sz: 10 },
      alignment: rightAlign,
      border: cellBorder
    };
    const tableHeaderStyle = {
      font: { bold: true, sz: 11 },
      alignment: center,
      border: cellBorder,
      fill: { fgColor: { rgb: "FFD9D9D9" } }
    };

    const styleCells = (r, colCount, styleForCol) => {
      for (let c = 0; c < colCount; c++) {
        const cell = XLSX.utils.encode_cell({ r, c });
        if (!ws[cell]) ws[cell] = { v: "", t: "s" };
        ws[cell].s = styleForCol(c);
      }
    };

    const addPairRows = (rows) => {
      rows.forEach((pairs) => {
        const colCount = pairs.length * 2;
        const rowData = new Array(colCount).fill("");
        pairs.forEach(([label, val], idx) => {
          rowData[idx * 2] = label;
          rowData[idx * 2 + 1] = val;
        });
        XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: { r: row, c: 0 } });
        styleCells(row, colCount, (c) => (c % 2 === 0 ? labelStyle : valueStyle));

        // Format numeric values in pair rows as numbers
        pairs.forEach(([, val], idx) => {
          const colIdx = idx * 2 + 1;
          const cellKey = XLSX.utils.encode_cell({ r: row, c: colIdx });
          if (ws[cellKey] && typeof val === "number") {
            ws[cellKey].v = val;
            ws[cellKey].t = "n";
            ws[cellKey].z = "#,##0.00";
            ws[cellKey].s = numStyle;
          }
        });

        row++;
      });
    };

    let row = 0;
    const companyName = StorageService.activeCompany()?.companyName || "";

    const headerReportDateStr = `Report Date: ${utility.formatExportDateTime(new Date())}`;
    XLSX.utils.sheet_add_aoa(
      ws,
      [[companyName, "", "", "", "", "", headerReportDateStr, "", "", ""]],
      { origin: { r: row, c: 0 } }
    );
    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 5 } });
    ws["!merges"].push({ s: { r: row, c: 6 }, e: { r: row, c: 9 } });
    ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
      font: { bold: true, sz: 12 },
      alignment: { horizontal: "left", vertical: "center" }
    };
    ws[XLSX.utils.encode_cell({ r: row, c: 6 })].s = {
      font: { bold: true, sz: 10 },
      alignment: { horizontal: "right", vertical: "center" }
    };
    row++;

    XLSX.utils.sheet_add_aoa(ws, [["Vehicle Reading Report"]], { origin: { r: row, c: 0 } });
    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 9 } });
    ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "center", vertical: "center" }
    };
    row += 2;

    const headerCategory = header.projectCategoryName || header.categoryName || (projects.find(p => String(p.id || p.projectId) === String(selectedProjectId) || (header.projectName && String(p.projectName).trim().toLowerCase() === String(header.projectName).trim().toLowerCase()))?.categoryName) || "";
    const headerCatInit = String(headerCategory).trim().charAt(0).toUpperCase();
    const excelProjName = header.projectName ? (headerCatInit ? `${headerCatInit}*${header.projectName}` : header.projectName) : "";

    XLSX.utils.sheet_add_aoa(
      ws,
      [["Project Name:", `${excelProjName}`, "", "", "", "", "", ""]],
      { origin: { r: row, c: 0 } }
    );
    ws["!merges"].push({ s: { r: row, c: 1 }, e: { r: row, c: 7 } });
    styleCells(row, 8, (c) => (c === 0 ? labelStyle : valueStyle));
    row++;

    const formatExportDate = (dateVal) => {
      if (!dateVal) return "";
      const d = new Date(dateVal);
      if (isNaN(d.getTime())) return String(dateVal);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    };

    addPairRows([
      [
        ["Vehicle Type:", header.vehicleType || ""],
        ["Vehicle No:", pickValue(header.vehicleNo, header.registrationNo, "")],
        ["Vendor(Vehicle Owner):", pickValue(header.vehicleOwner, header.vendorName, "")],
        ["Reading Type:", header.readingType || ""]
      ],
      [
        ["Hire Date:", header.hireStartDate ? formatExportDate(header.hireStartDate) : ""],
        ["Hire Type:", pickValue(header.hireType, header.leaseType, "")],
        ["Hire Rate:", Number(pickValue(header.hireRate, header.vehicleHirerate, 0)) || 0],
        ["Fuel Borne By:", header.fuelBorneBy || ""]
      ]
    ]);

    row++;

    const summaryRows = [
      [
        ["Working Days:", Number(summary.workingDays) || 0, "0"],
        ["Idle Days:", Number(summary.idleDays) || 0, "0"],
        ["Break Down Days:", Number(pickValue(summary.breakdownDays, summary.breakDownDays, 0)) || 0, "0"]
      ],
      [
        ["Start Date:", formatExportDate(fromDate || readingDate)],
        ["End Date:", formatExportDate(toDate || readingDate)],
        ["Total Days:", Number(summary.totalDays) || 0, "0"]
      ],
      [
        ["Start Reading:", Number(summary.startReading) || 0, "0.00"],
        ["End Reading:", Number(summary.endReading) || 0, "0.00"],
        ["Total Reading:", Number(totalReadingSum) || 0, "0.00"]
      ],
      [
        [
          pickValue(summary.fuelType, header.fuelType)
            ? `Total Fuel(Ltrs) (${pickValue(summary.fuelType, header.fuelType)}):`
            : "Total Fuel(Ltrs):",
          Number(pickValue(summary.totalFuelLiters, summary.totalFuel, totalFuelSum)) || 0,
          "0.00"
        ],
        ["Total Fuel Amt:", Number(totalFuelAmountSum) || 0, "0.00"],
        ["Vehicle Avg:", Number(getSafeAvg(pickValue(summary.vehicleAvg, summary.vehicleAverage, excelVehicleAvg()))) || 0, "0.00"]
      ]
    ];

    const chargesRows = [
      ["Total Hire Charges:", Number(pickValue(charges.totalHire, charges.totalHireCharges, 0)) || 0],
      ["Fuel Charges:", lessDiesel],
      ["Balance Payable:", balancePayable]
    ];

    for (let rIdx = 0; rIdx < 4; rIdx++) {
      const sPairs = summaryRows[rIdx];
      const cPair = chargesRows[rIdx];

      // Populate Summary columns (0 to 5)
      sPairs.forEach(([label, val, format], idx) => {
        const colLabel = idx * 2;
        const colVal = idx * 2 + 1;

        const cellLabelKey = XLSX.utils.encode_cell({ r: row, c: colLabel });
        ws[cellLabelKey] = { v: label || "", t: "s", s: labelStyle };

        const cellValKey = XLSX.utils.encode_cell({ r: row, c: colVal });
        if (typeof val === "number") {
          ws[cellValKey] = {
            v: val,
            t: "n",
            z: format || "0.00",
            s: valueStyle
          };
        } else {
          ws[cellValKey] = {
            v: val !== undefined && val !== null ? String(val) : "",
            t: "s",
            s: valueStyle
          };
        }
      });

      // Populate Charges columns (6 and 7) for rows 0, 1, 2
      if (cPair) {
        const [cLabel, cVal] = cPair;
        const cellCLabelKey = XLSX.utils.encode_cell({ r: row, c: 6 });
        ws[cellCLabelKey] = {
          v: cLabel,
          t: "s",
          s: { ...labelStyle, font: { bold: true, sz: 10 } }
        };

        const cellCValKey = XLSX.utils.encode_cell({ r: row, c: 7 });
        ws[cellCValKey] = {
          v: Number(cVal) || 0,
          t: "n",
          z: "#,##0.00",
          s: { ...numStyle, font: { bold: true, sz: 10 }, alignment: rightAlign }
        };
      }

      row++;
    }

    row++;

    const tableHeaders = [
      "Date",
      "Work Status",
      "Reading Type",
      "Start Reading",
      "End Reading",
      "Total Reading",
      "Fuel(Ltrs)",
      "Rate/Ltr",
      "Fuel Amount",
      "Driver Name"
    ];
    XLSX.utils.sheet_add_aoa(ws, [tableHeaders], { origin: { r: row, c: 0 } });
    styleCells(row, 10, () => tableHeaderStyle);
    row++;

    const toExcelDateSerial = (value) => {
      if (!value) return "-";
      const serial = utility.convertDateToExcelSerial(value);
      return serial !== null ? serial : "-";
    };

    sortedTable.forEach((item) => {
      const rawFrom = pickValue(item.fromReading, item.startReading, null);
      const rawTo = pickValue(item.toReading, item.endReading, null);
      const isNumFrom = rawFrom !== null && rawFrom !== "" && !isNaN(Number(rawFrom));
      const isNumTo = rawTo !== null && rawTo !== "" && !isNaN(Number(rawTo));
      const parsedFrom = isNumFrom
        ? Number(rawFrom)
        : (item.startTime ? utility.formatExportDateTime(item.startTime) : "-");
      const parsedTo = isNumTo
        ? Number(rawTo)
        : (item.endTime ? utility.formatExportDateTime(item.endTime) : "-");
      const rawDate = item.date || item.readingDate;
      const dateSerial = toExcelDateSerial(rawDate);

      const rowData = [
        dateSerial,
        pickValue(item.status, item.machineStatus, ""),
        pickValue(item.readingType, header.readingType, "-"),
        parsedFrom,
        parsedTo,
        calculateReading(item),
        Number(pickValue(item.fuelLiters, item.fuelLtrs, item.fuel, 0)) || 0,
        Number(pickValue(item.rate, 0)) || 0,
        Number(pickValue(item.fuelAmount, 0)) || 0,
        pickValue(item.driverName, "-")
      ];
      XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: { r: row, c: 0 } });
      styleCells(row, 10, (c) => {
        if (c === 0) return { ...valueStyle, alignment: center };
        if (c === 1 || c === 2 || c === 9) return { ...valueStyle, alignment: leftAlign };
        if (c === 3) return isNumFrom ? numStyle : { ...valueStyle, alignment: center };
        if (c === 4) return isNumTo ? numStyle : { ...valueStyle, alignment: center };
        if (c >= 5 && c <= 8) return numStyle;
        return valueStyle;
      });

      // Format Date cell as Excel date serial with dd-mm-yyyy format
      const dateCellKey = XLSX.utils.encode_cell({ r: row, c: 0 });
      if (ws[dateCellKey] && typeof ws[dateCellKey].v === "number") {
        ws[dateCellKey].t = "n";
        ws[dateCellKey].z = "dd-mm-yyyy";
      }

      // Format numeric cells as number type 'n'
      [3, 4, 5, 6, 7, 8].forEach((c) => {
        const cellKey = XLSX.utils.encode_cell({ r: row, c });
        if (ws[cellKey] && typeof ws[cellKey].v === "number") {
          ws[cellKey].t = "n";
          ws[cellKey].z = (c === 3 || c === 4 || c === 5) ? "0.00" : "#,##0.00";
        }
      });

      row++;
    });

    const totalReadingVal = Number(totalReadingSum) || 0;
    const totalFuelVal = Number(totalFuelSum) || 0;
    const totalFuelAmtVal = Number(totalFuelAmountSum) || 0;

    const totalsRow = [
      "", "", "", "",
      "Total:",
      totalReadingVal,
      totalFuelVal,
      "",
      totalFuelAmtVal,
      ""
    ];
    XLSX.utils.sheet_add_aoa(ws, [totalsRow], { origin: { r: row, c: 0 } });
    styleCells(row, 10, (c) => {
      if (c === 4) return { ...labelStyle, alignment: rightAlign };
      if (c === 5 || c === 6 || c === 8) return { ...numStyle, font: { bold: true } };
      return valueStyle;
    });

    [5, 6, 8].forEach((c) => {
      const cellKey = XLSX.utils.encode_cell({ r: row, c });
      if (ws[cellKey] && typeof ws[cellKey].v === "number") {
        ws[cellKey].t = "n";
        ws[cellKey].z = c === 5 ? "0.00" : "#,##0.00";
      }
    });

    // Compute dynamic column widths with padding and minimums
    const minWidths = [16, 16, 16, 20, 20, 16, 16, 16, 18, 22];
    const colWidths = [];
    for (let c = 0; c < 10; c++) {
      let maxLen = 0;
      Object.keys(ws).forEach((cellKey) => {
        if (cellKey.startsWith("!")) return;
        const pos = XLSX.utils.decode_cell(cellKey);
        if (pos.c === c) {
          if (pos.r <= 2) return; // Skip merged header/title rows
          const cell = ws[cellKey];
          if (cell && cell.v !== undefined && cell.v !== null) {
            let valStr = String(cell.v);
            if (cell.t === "n" && typeof cell.v === "number") {
              valStr = cell.v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            if (valStr.length > maxLen) {
              maxLen = valStr.length;
            }
          }
        }
      });
      colWidths[c] = { wch: Math.max(maxLen + 4, minWidths[c] || 16) };
    }

    ws["!cols"] = colWidths;

    ws["!ref"] = XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: row, c: 9 }
    });

    XLSX.utils.book_append_sheet(wb, ws, "Vehicle Reading");
    const fileName = `Vehicle_Reading_Report_${utility.formatDateDDMMMYYYY(new Date())}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };
  useEffect(() => {
    if (
      selectedProjectId === "" &&
      selectedVehicleId === "" &&
      vehicleType === "" &&
      vendorName === "" &&
      fromDate === "" &&
      toDate === ""
    ) {
      handleSearch();
    }
  }, [selectedProjectId, selectedVehicleId, vehicleType, vendorName, fromDate, toDate]);

  // useEffect(() => {
  //   loadReport();
  // }, [currentPage]);

  return (
    <>
      <Breadcrumb pageTitle="Vehicle Reading Report" secondTitle="Vehicle Management" />

      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="row">
        <div className="card py-3 bg-white shadow-sm">

          {/* 🔹 Filters Section */}
          <div className="row mb-3">

            {/* Reading Date */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Reading Date</label>
              <input
                type="date"
                className="form-control"
                value={readingDate}
                onChange={(e) => setReadingDate(e.target.value)}
              />
            </div>

            {/* Project Dropdown */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Project</label>
              <select
                className="form-select"
                value={selectedProjectId}
                onChange={handleProjectChange}
              >
                <option value="">Select Project</option>
                {projects.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.projectName}-{p.projectCode}
                  </option>
                ))}
              </select>
            </div>

            {/* Vehicle Type */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Vehicle Type</label>
              <select
                className="form-select"
                value={vehicleType}
                onChange={(e) => {
                  const val = e.target.value;
                  setVehicleType(val);
                  if (selectedVehicleId) {
                    const sel = vehicles.find(v => String(v.id) === selectedVehicleId);
                    if (sel && String(sel.vehicleTypeId) !== String(val) && val !== "") {
                      setSelectedVehicleId("");
                    }
                  }
                }}
              >
                <option value="">Select Vehicle Type</option>
                {[...new Map(vehicles.map(v => [v.vehicleTypeId, v])).values()].map((v) => (
                  <option key={v.vehicleTypeId} value={v.vehicleTypeId}>
                    {v.vehicleType}
                  </option>
                ))}
              </select>
            </div>

            {/* Vehicle Dropdown (Scrollable after 4–5 items) */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Vehicle</label>
              <select
                className="form-select vehicle-scroll-select"
                value={selectedVehicleId}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedVehicleId(value);

                  const selected = vehicles.find(v => String(v.id) === value);
                  if (selected) {
                    setVehicleType(selected.vehicleTypeId || "");
                    setVendorName(selected.vendorId || "");
                  }
                }}
              >
                <option value="">Select Vehicle</option>
                {vehicles
                  .filter((v) => !vehicleType || String(v.vehicleTypeId) === String(vehicleType))
                  .map((v) => (
                    <option key={v.id} value={v.id}>
                      ({v.vehicleType}) --- {v.vehicleName}-{v.registrationNo}
                    </option>
                  ))}
              </select>

              {selectedProjectId && vehicles.length === 0 && (
                <p className="text-danger mt-1" style={{ fontSize: "14px" }}>
                  No assigned vehicles for this project
                </p>
              )}
            </div>

            {/* Vendor Name */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Vendor Name</label>
              <select
                className="form-select"
                value={vendorName}
                onChange={(e) => {
                  const val = e.target.value;
                  setVendorName(val);
                  if (selectedVehicleId) {
                    const sel = vehicles.find(v => String(v.id) === selectedVehicleId);
                    if (sel && String(sel.vendorId) !== String(val) && val !== "") {
                      setSelectedVehicleId("");
                    }
                  }
                }}
              >
                <option value="">Select Vendor</option>
                {[...new Map(vehicles.map(v => [v.vendorId, v])).values()].map((v) => (
                  <option key={v.vendorId} value={v.vendorId}>
                    {v.vendorName}
                  </option>
                ))}
              </select>
            </div>

            {/* From Date */}
            <div className="col-md-3 mb-2">
              <label className="form-label">From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="col-md-3 mb-2">
              <label className="form-label">To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

          </div>

          {/* 🔹 Search Button */}

          <div className="mb-3 d-flex justify-content-end align-items-center">




            <div className="d-flex gap-2">
              {/* Clear Button */}
              <button
                className="btn btn-secondary"
                onClick={handleClearFilters}
              >
                <i className="ti ti-refresh me-1"></i>
                Clear
              </button>

              {/* View Button */}
              <button
                className="btn btn-primary"
                onClick={handleSearchClick}
                disabled={loading}
              >
                <i className="ti ti-search me-1"></i>
                {loading ? "Searching..." : "View Report"}
              </button>
            </div>
          </div>

          <hr></hr>
          <div className="mb-3 d-flex justify-content-end align-items-center">

            <div className="d-flex gap-2">
              <button
                className="btn btn-success"
                onClick={handleExportPDF}
              >
                Export PDF
              </button>

              <button
                className="btn btn-success"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
            </div>



          </div>
          {/* 🔹 Report Table */}
          <div className="table-responsive">

            <table className="table table-striped table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Reading Date</th>
                  <th>Project</th>
                  <th>Vendor Name</th>
                  <th>Vehicle Type</th>
                  <th>Owner Name</th>
                  <th>Registration No</th>
                  <th>Machine Status</th>
                  <th>Reading Type</th>
                  <th>Start Reading</th>
                  <th>End Reading</th>
                  <th>Total Readings</th>
                  <th>Fuel(Ltrs)</th>
                  <th>Rate/Ltr</th>
                  <th>Fuel Amount</th>
                  <th>Hire Type</th>
                  <th>Hire Amount</th>
                  <th>Driver Name</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="18" className="text-center py-4">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : reports.length === 0 ? (
                  <tr>
                    <td colSpan="18" className="text-center text-muted">
                      No vehicle report found
                    </td>
                  </tr>
                ) : (
                  reports.map((r, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        {/* <td>{index + 1}</td> */}
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{utility.formatDateDDMMMYYYY(r.readingDate)}</td>
                        <td>{r.projectName ? (() => {
                          const cat = r.projectCategoryName || r.categoryName || r.category || (projects.find(p => String(p.id || p.projectId) === String(r.projectId || selectedProjectId) || (r.projectName && String(p.projectName).trim().toLowerCase() === String(r.projectName).trim().toLowerCase()))?.categoryName) || "";
                          const init = String(cat).trim().charAt(0).toUpperCase();
                          return init ? `${init}*${r.projectName}` : r.projectName;
                        })() : "-"}</td>
                        <td>{r.vendorName || "-"}</td>
                        <td>{r.vehicleType || "-"}</td>
                        <td>{r.vehicleName || "-"}</td>
                        <td>{r.registrationNo || "-"}</td>
                        <td>{r.machineStatus || "-"}</td>
                        <td>{r.readingType || "-"}</td>
                        <td>{r.fromReading !== null && r.fromReading !== "" && r.fromReading !== undefined ? r.fromReading : (r.startTime ? utility.formatDbDateTime(r.startTime) : "-")}</td>
                        <td>{r.toReading !== null && r.toReading !== "" && r.toReading !== undefined && Number(r.toReading) > 0 ? r.toReading : (r.endTime ? utility.formatDbDateTime(r.endTime) : "-")}</td>
                        <td>{r.totalReading ? Number(r.totalReading).toFixed(2) : "0.00"}</td>
                        <td>{r.fuelLiters !== undefined && r.fuelLiters !== null ? Number(r.fuelLiters).toFixed(2) : "0.00"}</td>
                        <td>{r.rate !== undefined && r.rate !== null ? Number(r.rate).toFixed(2) : "0.00"}</td>
                        <td>{r.fuelAmount !== undefined && r.fuelAmount !== null ? Number(r.fuelAmount).toFixed(2) : "0.00"}</td>
                        <td>{r.leaseType || "-"}</td>
                        <td>{r.vehicleHirerate || 0}</td>
                        <td>{r.driverName || "-"}</td>
                      </tr>
                    </React.Fragment>
                  ))
                )}
              </tbody>
            </table>

            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="< Previous"
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />


          </div>

        </div>
      </div>
    </>
  );
}
